import { render, staticRenderFns } from "./imprDetail.vue?vue&type=template&id=155d551e&scoped=true"
import script from "./imprDetail.vue?vue&type=script&lang=js"
export * from "./imprDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155d551e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('155d551e')) {
      api.createRecord('155d551e', component.options)
    } else {
      api.reload('155d551e', component.options)
    }
    module.hot.accept("./imprDetail.vue?vue&type=template&id=155d551e&scoped=true", function () {
      api.rerender('155d551e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/ibm/imprDetail.vue"
export default component.exports